import React from 'react';
import { Button } from './ui/button';
import { Users, Maximize2, Wifi, Coffee } from 'lucide-react';
import { roomTypes } from '@/lib/config';

const AvailableRooms = ({ checkIn, checkOut, adults, kids, onClose, onBookNow }) => {
  if (!checkIn || !checkOut) return null;

  const scrollToRooms = () => {
    const element = document.getElementById('facilities');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close the available rooms section
    if (onClose) onClose();
  };

  const calculateNights = () => {
    const diffTime = Math.abs(checkOut - checkIn);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const nights = calculateNights();

  return (
    <section className="available-rooms-section">
      <div className="section-container">
        <div className="available-rooms-header">
          <div>
            <h2 className="available-rooms-main-title">Available Rooms for Your Stay</h2>
            <p className="available-rooms-dates">
              {checkIn.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} - {checkOut.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} • {nights} {nights === 1 ? 'Night' : 'Nights'} • {adults} {parseInt(adults) === 1 ? 'Adult' : 'Adults'}
              {parseInt(kids) > 0 && `, ${kids} ${parseInt(kids) === 1 ? 'Kid' : 'Kids'}`}
            </p>
          </div>
          {onClose && (
            <button className="close-available-rooms" onClick={onClose}>
              ×
            </button>
          )}
        </div>

        <div className="available-rooms-list">
          {roomTypes.map((room) => {
            const totalCost = room.price * nights;
            
            return (
              <div key={room.id} className="available-room-item">
                <div className="available-room-image-section">
                  <img 
                    src={`https://images.unsplash.com/photo-${room.id === 1 ? '1611892440504-42a792e24d32' : '1582719478250-c89cae4dc85b'}?w=400&h=300&fit=crop`}
                    alt={room.name}
                    className="available-room-thumbnail"
                  />
                </div>

                <div className="available-room-content">
                  <div className="available-room-header-section">
                    <h3 className="available-room-name">{room.name}</h3>
                    <div className="available-room-pricing">
                      <span className="available-room-price">₹{room.price.toLocaleString()}</span>
                      <span className="available-room-price-label">/night</span>
                    </div>
                  </div>

                  <div className="available-room-features-grid">
                    <div className="available-room-feature-item">
                      <Maximize2 size={18} />
                      <span>{room.id === 1 ? '350' : '450'} sq ft</span>
                    </div>
                    <div className="available-room-feature-item">
                      <Users size={18} />
                      <span>Up to {room.id === 1 ? '2' : '3'} guests</span>
                    </div>
                    <div className="available-room-feature-item">
                      <Wifi size={18} />
                      <span>Free WiFi</span>
                    </div>
                    <div className="available-room-feature-item">
                      <Coffee size={18} />
                      <span>Breakfast included</span>
                    </div>
                  </div>

                  <div className="available-room-total">
                    <span className="available-room-total-label">Total for {nights} {nights === 1 ? 'night' : 'nights'}:</span>
                    <span className="available-room-total-price">₹{totalCost.toLocaleString()}</span>
                  </div>

                  <div className="available-room-actions">
                    <Button onClick={scrollToRooms} variant="outline" className="view-more-btn">
                      View More Details
                    </Button>
                    <Button  onClick={() => {
                      if (onBookNow) onBookNow(room.name);
                        document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="book-room-btn">
                      Book Now
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AvailableRooms;
